import React from 'react';
import { EditIcon, TrashIcon, GlobeIcon, CoinsIcon } from 'lucide-react';
export function CountryList({
  countries,
  onSelectCountry,
  onDeleteCountry,
  locale
}) {
  // Group countries by region for better organization
  const countryByRegion = countries.reduce((acc, country) => {
    if (!acc[country.region]) {
      acc[country.region] = [];
    }
    acc[country.region].push(country);
    return acc;
  }, {});
  // Sort regions alphabetically
  const sortedRegions = Object.keys(countryByRegion).sort();
  return <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-14787">
      {countries.length === 0 ? <div className="px-4 py-5 sm:p-6 text-center text-gray-500" data-id="element-14788">
          No countries found. Add a new country to get started.
        </div> : <>
          {sortedRegions.map(region => <div key={region} className="border-b border-gray-200 last:border-b-0" data-id="element-14789">
              <div className="bg-gray-50 px-4 py-2" data-id="element-14790">
                <h3 className="text-sm font-medium text-gray-700" data-id="element-14791">{region}</h3>
              </div>
              <ul className="divide-y divide-gray-200" data-id="element-14792">
                {countryByRegion[region].sort((a, b) => a.name.localeCompare(b.name)).map(country => <li key={country.alpha2Code} data-id="element-14793">
                      <div className="px-4 py-4 flex items-center justify-between hover:bg-gray-50" data-id="element-14794">
                        <div className="flex-1 cursor-pointer" onClick={() => onSelectCountry(country)} data-id="element-14795">
                          <div className="flex items-center" data-id="element-14796">
                            <div className="min-w-0 flex-1" data-id="element-14797">
                              <div className="flex items-center" data-id="element-14798">
                                <p className="text-sm font-medium text-indigo-600 truncate" data-id="element-14799">
                                  {country.name}
                                </p>
                                <p className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-14800">
                                  {country.alpha2Code}
                                </p>
                                <p className="ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800" data-id="element-14801">
                                  {country.alpha3Code}
                                </p>
                              </div>
                              <div className="mt-2 flex items-center text-sm text-gray-500" data-id="element-14802">
                                <div className="flex items-center mr-4" data-id="element-14803">
                                  <GlobeIcon className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" data-id="element-14804" />
                                  <span data-id="element-14805">{country.subRegion}</span>
                                </div>
                                <div className="flex items-center mr-4" data-id="element-14806">
                                  <CoinsIcon className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" data-id="element-14807" />
                                  <span data-id="element-14808">{country.officialCurrency}</span>
                                </div>
                                <div className="flex items-center" data-id="element-14809">
                                  <span className="text-gray-400 mr-1" data-id="element-14810">
                                    Phone:
                                  </span>
                                  <span data-id="element-14811">{country.phoneCode}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="ml-4 flex-shrink-0 flex" data-id="element-14812">
                          <button type="button" onClick={() => onSelectCountry(country)} className="mr-2 inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-14813">
                            <EditIcon className="h-4 w-4 mr-1" data-id="element-14814" />
                            Edit
                          </button>
                          <button type="button" onClick={e => {
                  e.stopPropagation();
                  onDeleteCountry(country);
                }} className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-14815">
                            <TrashIcon className="h-4 w-4 mr-1" data-id="element-14816" />
                            Delete
                          </button>
                        </div>
                      </div>
                    </li>)}
              </ul>
            </div>)}
        </>}
    </div>;
}